import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../../hooks/useStore';
import { HrisPauseView } from './view';
import { HrisPauseForm } from './form';
import { DataViewEditBox, useForm } from '../../../../../lib/components';
import { useState } from 'react';
import * as Yup from 'yup';

export const HrisPause = observer(() => {
  const { t } = useTranslation();
  const { companyStore } = useStore();
  const [canSubmit, setCanSubmit] = useState<boolean>(false);
  const form = useForm();

  const data = {
    status: companyStore.settings?.hris_integration_status === 'PAUSED' ? true : false,
    date: companyStore.settings?.hris_pause_date
  };

  const renderView = () => <HrisPauseView data={companyStore.settings} />;

  const renderEdit = () => {
    return (
      <HrisPauseForm
        validationSchema={{
          date: Yup.date()
            .nullable()
            .typeError(t('form:INVALID_DATE'))
            .min(new Date(), t('form:DATE_MUST_NOT_BE_IN_THE_PAST'))
        }}
        initialValues={data}
        formRef={form.formRef}
        onStateChanged={setCanSubmit}
        onSubmit={async (updatedValues) => {
          try {
            await companyStore.updateSettings({
              hris_integration_status: updatedValues.status ? 'PAUSED' : 'CONNECTION_COMPLETE',
              hris_pause_date:
                updatedValues.status && updatedValues.date ? updatedValues.date : null
            });
          } catch (error) {
            console.error(error);
          }
        }}
        useCustomButton
      />
    );
  };

  return (
    <DataViewEditBox
      title={t(`company:HRIS_PAUSE_SYNC`)}
      view={renderView}
      edit={renderEdit}
      canEdit
      canSubmit={canSubmit}
      onSubmit={form.handleSubmit}
      onCancel={form.handleReset}
    />
  );
});
